import { Box, styled } from '@mui/material';
import { useLocation, useParams } from 'react-router';

import ActionButton from '../../components/ActionButton/index.ts';
import Page from '../../components/Page/index.ts';
import Section from '../../components/Section/index.ts';
import StaticPageLayout from '../../components/StaticPageLayout/index.ts';
import { LANG } from '../../services/Config.js';

import faqArticlesData from './data.json';
import FakeBob from './FakeBob/index.ts';

type GetTypeParams = {
  type: string;
  appStrings: typeof LANG.appStrings;
  routes: typeof LANG.routes;
};

const BobContainer = styled(Box)(() => ({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const StyledFakeBob = styled(FakeBob)(() => ({
  // fixed height: one bubble + button
  height: 145,
  '& > div:first-child': {
    alignSelf: 'center',
  },
}));

const getType = ({ type, appStrings, routes }: GetTypeParams) => {
  switch (type) {
    // ???
    // case 'mobile':
    // case 'mobilabonnement':
    // case 'mobil':
    //   return {
    //     flow: 'mobile_onboarding',
    //     step: 'init_with_fixed_start',
    //     redirect: generatePath(routes.PRODUCTS_MOBILE, {
    //       product: routes.MOBILE_PREFIX,
    //     }),
    //     name: appStrings.PRODUCTS.MOBILE_SUBSCRIPTION,
    //   };
    // case 'forsikring':
    // case 'insurance':
    //   return {
    //     flow: 'insurance_leads',
    //     step: 'init_with_fixed_start',
    //     redirect: routes.PRODUCTS_INSURANCE,
    //     name: appStrings.PRODUCTS.INSURANCE,
    //   };
    case 'refinansiering':
    case 'refinancing':
      return {
        flow: 'debt_check',
        step: 'skip_start',
        redirect: routes.PRODUCTS_REFINANCING,
        name: appStrings.PRODUCTS.REFINANCING,
      };
    default:
      return {};
  }
};

const FaqArticle: React.FC = () => {
  const { appStrings, routes } = LANG;

  const { pathname } = useLocation();
  const { articleName } = useParams();
  const productName = pathname.split('/');
  const type = getType({ type: productName[1], appStrings, routes });

  const data = faqArticlesData[articleName as keyof typeof faqArticlesData];

  const capitalize = (s: string): string => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  return (
    <Page title={`${data.title} - ${capitalize(productName[1])}`}>
      <StaticPageLayout
        title={data.title}
        breadcrumbsItems={[
          { text: appStrings.MENU.HOME, url: routes.HOME },
          { text: type?.name || '', url: type?.redirect || '' },
          { text: data.title },
        ]}
      >
        <div dangerouslySetInnerHTML={{ __html: data.content || '' }} />
      </StaticPageLayout>

      <Section last>
        <BobContainer>
          <h2 className="typography-v1-legacy-h2">Betaler du mer enn du må?</h2>
          <h3 className="mt-2 typography-v1-legacy-subtitle2">
            På 2 minutter sjekker du enkelt om du kan spare på refinansiering.
          </h3>

          <StyledFakeBob
            messages={[
              {
                text: 'Logg på med BankID og se om du kan spare.',
              },
              {
                type: 'button',
                renderContent: () => (
                  <ActionButton
                    label="Sjekk nå"
                    step="skip_start"
                    flow="debt_check"
                    color="secondary"
                  />
                ),
              },
            ]}
          />
        </BobContainer>
      </Section>
    </Page>
  );
};

export default FaqArticle;
